const OtherHooks = () => {
    return (
        <div className="demo-container">
            <div className="demo-box">
                <code>Hooks like useInsertionEffect and useSyncExternalStore are meant for library authors</code>
            </div>
        </div>  
    )
}

export default OtherHooks